{
    "ClientConfiguration_Table_Headers_Description": "Beschreibung",
    "ClientConfiguration_Table_Headers_TelSys": "Telefonieserver",
    "ClientConfiguration_Table_Headers_Partition": "Partition",
    "ClientConfiguration_Table_Headers_Device": "Gerät",
    "ClientConfiguration_Footer_Add": "Hinzufügen",
    "ClientConfiguration_Footer_View": "Sicht",
    "ClientConfiguration_Footer_Change": "Ändern",
    "ClientConfiguration_Footer_Delete": "Löschen",
    "ClientConfiguration_Footer_Selected": "{} Ausgewählt",
    "ClientConfiguration_Footer_NoRows": "Hier gibt es nichts zu sehen...",
    "ClientConfiguration_No_Available_CMEs": "Sie verfügen über keine CMEs mit den erforderlichen Fähigkeiten",
    "NAME": "ClientConfigurationLanguage",
    "ClientConfiguration_Table_Headers_CME": "Telefonieserver",
    "ClientConfiguration_Admin_Filters_CME": "CME",
    "ClientConfiguration_Admin_Filters_IncludeChildCMEs": "Kinder-CME einschließen",
    "ClientConfiguration_Admin_Filters_Search": "Suchen"
}